import { render } from "./FormErrors.vue?vue&type=template&id=649bb74e"
import script from "./FormErrors.vue?vue&type=script&lang=js"
export * from "./FormErrors.vue?vue&type=script&lang=js"
script.render = render

export default script